import { useInformationBannerApi } from '@app/guards/information-banner.hook'

export default defineNuxtRouteMiddleware(() => {
  void useInformationBannerApi()
})
